const commonMessage = {
  login: "Welcome Back!",
  logout: "Logout Successfully!",
};

const formMessage = {
  email: "Email is required!",
  user_req: "Username is required!",
  pass_req: "Password is required!",
  firstname: "Firstname is required!",
  lastname: "Lastname is required!",
  course: "Please select course!",
};

const dataMessage = {
  noData: "No data to display",
  noCourses: "No Courses to display",
  noModules: "No Course Modules to display",
};

export { commonMessage, formMessage, dataMessage };
